import { useEffect } from "react";
import { useDataCache } from "@newageerp/v3.app.data-cache-provider";
import { useSelector } from "@newageerp/v3.templates.templates-core";
import { SelectorWebhookNae } from "../models/ormSelectors";

interface ChildId {
  id: number
}

export interface IWebhookModelNae {
    _viewTitle: string,
      id: number,
      scopes: any,
      badges: any,
  }

export const IWebhookFieldsNae = [
    "_viewTitle",
    "id",
    "scopes",
    "badges"
];

export function useWebhookHookNae(id: number) : IWebhookModelNae {
  // @ts-ignore
  const element = useSelector((state) => SelectorWebhookNae(state, id));

  const { addToQueue } = useDataCache();

  useEffect(() => {
    if (!element) {
      addToQueue({
        elementId: id,
        schema: "webhook",
        fields: IWebhookFieldsNae,
      });
    }
  }, [element, id]);

  return element;
}
